import { cn } from "@/lib/utils/cn"

interface SpinnerProps {
  size?: "sm" | "md" | "lg"
  label?: string
  className?: string
}

const sizeMap = {
  sm: "h-4 w-4 border-2",
  md: "h-8 w-8 border-[3px]",
  lg: "h-12 w-12 border-4",
}

export function Spinner({ size = "md", label, className }: SpinnerProps) {
  return (
    <div className={cn("flex flex-col items-center gap-3", className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-[var(--color-accent-blue)] border-t-transparent",
          sizeMap[size],
        )}
        role="status"
        aria-label={label ?? "Loading"}
      />
      {label && (
        <p className="text-sm text-[var(--color-text-muted)]">{label}</p>
      )}
    </div>
  )
}
